Object.defineProperty(exports, "__esModule", {
    value: true
});
var _object_spread = require("@swc/helpers/_/_object_spread");
//#region src/normalizeOptions.ts
function normalizeOptions(enableDefault, defaultOptions, key) {
    return function(options) {
        if (options === false) return false;
        if (typeof options === "undefined") if (enableDefault) return defaultOptions;
        else return false;
        if (options === true) return defaultOptions;
        if (options && typeof options === "object") return _object_spread._({}, defaultOptions, options);
        throw new Error(`Unexpected type for \`${key}\`, expect boolean/undefined/object, got: ${typeof options}`);
    };
}
//#endregion
exports.normalizeOptions = normalizeOptions; //# sourceMappingURL=normalizeOptions.cjs.map
